import React from 'react';

const EDENRED_CLIENT_ID = 'd0c36153-a122-4c1e-bdeb-8a4918be123e';

interface EdenredStatusBadgeProps {
  clientId: string;
  edenredStatus?: string | null;
}

const EdenredStatusBadge: React.FC<EdenredStatusBadgeProps> = ({ clientId, edenredStatus }) => {
  if (clientId !== EDENRED_CLIENT_ID) {
    return null;
  }

  let statusColor = '#9ca3af';
  let statusText = 'Non envoyé';

  if (edenredStatus === 'sent') {
    statusColor = '#22c55e';
    statusText = 'Envoyé Edenred';
  } else if (edenredStatus === 'error') {
    statusColor = '#ef4444';
    statusText = 'Erreur envoi';
  }

  return (
    <div className="flex items-center gap-1.5 text-[11px] font-medium">
      <div
        className="w-2 h-2 rounded-full flex-shrink-0"
        style={{ backgroundColor: statusColor }}
      />
      <span style={{ color: statusColor }}>
        {statusText}
      </span>
    </div>
  );
};

export default EdenredStatusBadge;
